import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import CartTimelineOverview from "@components/widgets/reports/cartTimeline/CartTimelineOverview";

const CartTimeline = () => {
    const route: Route = useMemo(() => router.cartTimeline, []);

    return (
        <AdminLayout currentPage={route}>
            <CartTimelineOverview route={route}/>
        </AdminLayout>
    );
};

export default CartTimeline;